<template>
  <v-flex xs12 sm12 md12>
    <v-layout wrap>
      <v-flex xs12 sm12 md6>
        <v-text-field v-model="store.api_key"
                      name="shop"
                      :label="$t('attrs.api_key')"
                      v-validate="'required'"
                      :error-messages="errors.collect('api_key')"
                      data-vv-name="api_key"
                      :data-vv-as="$t('attrs.api_key')"
                      required
                      ></v-text-field>
        <v-text-field v-model="store.api_secret"
                      name="api_secret"
                      :label="$t('attrs.api_secret')"
                      v-validate="'required'"
                      :error-messages="errors.collect('api_secret')"
                      data-vv-name="api_secret"
                      :data-vv-as="$t('attrs.api_secret')"
                      required
                      ></v-text-field>
        <v-select v-model="store.woocommerce_version"
                  :items="versions"
                  item-value="id"
                  item-text="name"
                  :label="$t('attrs.woocommerce_version')"
                  ></v-select>
        <v-select v-model="store.woocommerce_legacy_api"
                  :items="legacy"
                  item-value="id"
                  item-text="name"
                  :label="$t('attrs.woocommerce_legacy_api')"
                  ></v-select>
      </v-flex>

      <v-flex xs12 sm12 md6>
        <v-layout wrap>

          <v-flex xs12 sm12 md4>
            <v-text-field v-model="address.name"
                          name="name"
                          :label="$t('attrs.name')"
                          v-validate="'required'"
                          :error-messages="errors.collect('name')"
                          data-vv-name="name"
                          :data-vv-as="$t('attrs.name')"
                          required
                          ></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md4>
            <v-text-field v-model="address.company"
                          name="company"
                          :label="$t('attrs.company')"
                          v-validate="'required'"
                          :error-messages="errors.collect('company')"
                          data-vv-name="company"
                          :data-vv-as="$t('attrs.company')"
                          required
                          ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-text-field v-model="address.email"
                          name="email"
                          :label="$t('attrs.email')"
                          v-validate="'required'"
                          :error-messages="errors.collect('email')"
                          data-vv-name="email"
                          :data-vv-as="$t('attrs.email')"
                          required
                          ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-text-field v-model="address.phone"
                          name="phone"
                          :label="$t('attrs.phone')"
                          v-validate="'required'"
                          :error-messages="errors.collect('phone')"
                          data-vv-name="phone"
                          :data-vv-as="$t('attrs.phone')"
                          required
                          ></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md4>
            <v-text-field v-model="address.street"
                          name="street"
                          :label="$t('attrs.street+number')"
                          v-validate="'required'"
                          :error-messages="errors.collect('street')"
                          data-vv-name="street"
                          :data-vv-as="$t('attrs.street+number')"
                          required
                          ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-text-field v-model="address.neighborhood"
                          name="neighborhood"
                          :label="$t('attrs.neighborhood')"
                          v-validate="'required'"
                          :error-messages="errors.collect('neighborhood')"
                          data-vv-name="neighborhood"
                          :data-vv-as="$t('attrs.neighborhood')"
                          required
                          ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-text-field v-model="address.city"
                          name="city"
                          :label="$t('attrs.city')"
                          v-validate="'required'"
                          :error-messages="errors.collect('city')"
                          data-vv-name="city"
                          :data-vv-as="$t('attrs.city')"
                          required
                          ></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md4>
            <v-text-field v-model="address.postal_code"
                          name="postal_code"
                          :label="$t('attrs.postal_code')"
                          v-validate="'required'"
                          :error-messages="errors.collect('postal_code')"
                          data-vv-name="postal_code"
                          :data-vv-as="$t('attrs.postal_code')"
                          required
                          ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-select v-model="address.country_id"
                      :items="countries"
                      item-value="id"
                      item-text="name"
                      :label="$tc('models.country')"
                      @change="fetchStates"
                      ></v-select>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-select v-model="address.state"
                      :items="states"
                      item-value="name"
                      item-text="name"
                      :label="$tc('models.state')"
                      :disabled="!address.country_id"
                      ></v-select>
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import Country from '@/client/country'
import State from '@/client/state'

export default {
  name: 'StoreWoocommerceComp',

  props: {
    store: {},
    address: {}
  },

  data () {
    return {
      countries: [],
      states: [],
      versions: [
        { id: '3', name: '3.x' },
        { id: '2', name: '2.x' },
        { id: '1', name: '1.x' }
      ],
      legacy: [
        { id: false, name: this.$t('no') },
        { id: true, name: this.$t('yes') }
      ]
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetchStates () {
      this.states = []
      this.states = await State.all({
        where: { country_id: this.address.country_id },
        per_page: 2000
      })
    }
  },

  watch: {
  },

  async mounted () {
    this.countries = await Country.all({ per_page: 2000, order: 'name ASC', fast_search: true })
    this.fetchStates()
  }
}
</script>
